import Vue from 'vue';
import App from './App.vue';
// import I18n from "vue-i18n";
import store from './store/index';
// import loc from "./i18n/index";
import i18n from '@/i18n';

import './assets/css/reset.css';
import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SvgIcon from '@/components/SvgIcon'; // svg组件
import router from './router';

// 注册到全局
Vue.component('svg-icon', SvgIcon);

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context('./icons/svg', false, /\.svg$/);
requireAll(req);
// import './assets/js/rem.js'
Vue.config.productionTip = false;
// Vue.use(I18n);
Vue.use(element);
// const i18n = new I18n({
//   locale: "en",
//   fallbackLocale: "en",
//   messages: {
//     en: loc.en,
//     zh: loc["zh"],
//     ar: loc["ar"],
//   },
// });

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('custom-render-trigger'));
  },
}).$mount('#app');
